$(document).ready(function () {
    const $stickyButton = $('#sticky-save-button');
    const $scrollButton = $('#scroll-to-product-button');
    const $reviewsCarousel = $('.reviews-carousel');
    const $productTitle = $('.product__title');

    if (!$stickyButton.length || !$reviewsCarousel.length || !$productTitle.length) {
        return;
    }

    let buttonVisible = false;

    // Hide button initially
    $stickyButton.hide();

    // Check if user has scrolled past the bottom of the element
    function hasScrolledPastElement($element) {
        const rect = $element[0].getBoundingClientRect();
        return rect.bottom < 0;
    }

    // Check if user is above the element
    function isAboveElement($element) {
        const rect = $element[0].getBoundingClientRect();
        return rect.top > 0;
    }

    function updateStickyButtonVisibility() {
        if ($(window).width() > 768) {
            $stickyButton.hide();
            buttonVisible = false;
            return;
        }

        if (hasScrolledPastElement($reviewsCarousel)) {
            if (!buttonVisible) {
                $stickyButton.show();
                buttonVisible = true;
            }
        } else if (isAboveElement($reviewsCarousel)) {
            if (buttonVisible) {
                $stickyButton.hide();
                buttonVisible = false;
            }
        }
    }

    function scrollToProductTitle() {
        $('html, body').animate({
            scrollTop: $productTitle.offset().top
        }, 800);
        $stickyButton.hide();
        buttonVisible = false;
    }

    $(window).on('load', function () {
        setTimeout(function () {
            $(window).on('scroll resize', updateStickyButtonVisibility);
            updateStickyButtonVisibility(); // initial check after delay
        }, 500); // adjust delay as needed
    });

    $stickyButton.on('click', scrollToProductTitle);
    $scrollButton.on('click', scrollToProductTitle);
});
